"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.seriesSchemaDef = exports.submissionWindowBaseSchemaDef = exports.seriesBaseSchemaDef = exports.dateSchema = exports.dateTimeFormat = void 0;
const joi_1 = __importDefault(require("joi"));
const general_1 = require("../general");
const BusinessUnit_1 = require("../shared/BusinessUnit");
const schemaValidator_1 = require("../../util/schemaValidator");
exports.dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.sssZ';
const dateSchema = () => joi_1.default.date().iso().raw(true);
exports.dateSchema = dateSchema;
exports.seriesBaseSchemaDef = {
    _id: general_1.daoObjSchemaDef._id,
    id: joi_1.default.number().positive().required(),
    name: joi_1.default.string().required(),
    year: joi_1.default.number().required(),
    month: joi_1.default.number().required(),
};
exports.submissionWindowBaseSchemaDef = {
    name: joi_1.default.string().required(),
    buffer: (0, exports.dateSchema)(),
    chaseBuffer: (0, exports.dateSchema)(),
};
exports.seriesSchemaDef = Object.assign(Object.assign(Object.assign({}, general_1.daoObjSchemaDef), exports.seriesBaseSchemaDef), { businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(), startDate: (0, exports.dateSchema)().required(), endDate: (0, exports.dateSchema)().required(), active: joi_1.default.boolean().required(), submissionWindows: (0, schemaValidator_1.arraySchema)(exports.submissionWindowBaseSchemaDef).default([]) });
